// SignOutButton — DRY: the one sign-out control, used by AppShell and AuthLayout.
// Renders nothing without a user, or while the dev-only role switcher is active
// (a dev role has no real session to end).
import { useState } from "react";
import { useAuth } from "../../hooks/useAuth.js";
import { getDevRole } from "../../hooks/devRole.js";

interface SignOutButtonProps {
  className?: string;
}

const BUTTON = "rounded-md px-3 py-2 text-left text-sm text-white/80 hover:bg-dm-blue/50 disabled:opacity-60";

export default function SignOutButton({ className }: SignOutButtonProps) {
  const { user, signOut } = useAuth();
  const [pending, setPending] = useState(false);
  const [failed, setFailed]   = useState(false);

  // Same guard as AuthProvider.
  const devRole = import.meta.env.DEV ? getDevRole() : null;
  if (!user || devRole) return null;

  async function handleClick() {
    setPending(true);
    setFailed(false);
    const ok = await signOut();
    // On success the page is navigating away; keep the pending state.
    if (!ok) {
      setPending(false);
      setFailed(true);
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={() => void handleClick()}
        disabled={pending}
        className={className ? `${BUTTON} ${className}` : BUTTON}
      >
        {pending ? "Signing out…" : failed ? "Try again" : "Sign out"}
      </button>
      <span className="sr-only" aria-live="polite">
        {failed ? "Sign out failed. Please try again." : ""}
      </span>
    </>
  );
}
